angular.module('rjmNg.services').factory 'rjqlFormula', [
  "infixParser"
  "infixParserForRjql"
  "infixFilterParser"
  "encodedLetterString"
  (infixParser, infixParserForRjql, infixFilterParser, encodedLetterString) ->

    getExpressionWithMeasures: (expressionText, measures, version=0.1) ->
      boundPrefixExpression = @evaluateFormulaIfValid expressionText, measures, 'formula', version
      return boundPrefixExpression

    # Get the definitions of each referenceable measure
    getColumnNames : (metrics, version=0.1) ->
      columns = []
      for metric in metrics
        if metric.function isnt 'standard' and metric.type is 'metric'
          columns.push @_getColumn(metric, version)
        else
          columns.push metric.alias
      return columns

    _getColumn : (metric, version=0.1) ->
      switch version
        when 0.1 then @_getColumn_0_1(metric)
        when 1.0 then @_getColumn_1_0(metric)

    _getColumn_0_1 : (metric) ->
      type: 'function'
      function: metric.function
      field: [metric.alias, ":value"]
      time: [metric.alias, ":time"]
      offset: metric.offset

    _getColumn_1_0 : (metric) ->
      type: 'function'
      function: metric.function
      field: [metric.alias, ":value"]
      by: ":time"
      offset: metric.offset
      op: metric.op

    getColumnAliases : (metrics) ->
      columns = []
      for metric in metrics
        columns.push metric.alias
      return columns

    genSymbolBindings : (symbols) ->
      symbolMap = {}
      for symbol, i in symbols
        symbolMap[encodedLetterString.numToLetter(i)] = symbol
      return symbolMap

    # Used to go backwards
    genReferenceBindings : (symbols) ->
      map = {}
      for symbol, i in symbols
        map[symbol] = encodedLetterString.numToLetter(i)
      return map

    # infixExpression - an infix string like "A + B"
    # columnNames - a list of columns names like ['Clients', 'Revenue']
    evaluateFormulaIfValid : (infixExpression, columnNames, parserType, version) ->
      # If we get a number here, cast it to a string for the parser
      # This can happen if we have a formula that is just an explicit number
      if typeof infixExpression is 'number'
        infixExpression = "#{infixExpression}"

      symbolBindings = @genSymbolBindings columnNames
      try
        switch parserType
          when 'filter'
            unboundPrefixExpression = infixFilterParser.parse(infixExpression)
          else
            if version >= 1.0
              unboundPrefixExpression = infixParserForRjql.parse(infixExpression)
            else
              unboundPrefixExpression = infixParser.parse(infixExpression)
        boundPrefixExpression = @bindLabelsToPrefixExpression unboundPrefixExpression, symbolBindings
      catch error
        boundPrefixExpression = false
      boundPrefixExpression

    ###
      Recursively binds an unbound prefix expression, eg:
        ["/", ["A", ":value"], ["B", ":value"]]
      with a symbol map, eg:
        ["A" : "Clients", "B" : "Revenue"]
      which results in a bound prefix expression like:
        ["/". ["Clients", ":value"], ["Revenue", ":value"]]
    ###
    bindLabelsToPrefixExpression: (unboundPrefixExpression, symbolBindings) ->
      unless unboundPrefixExpression instanceof Array
        if unboundPrefixExpression of symbolBindings
          return @_getMeasureReference(unboundPrefixExpression, symbolBindings)
        else if not isNaN(unboundPrefixExpression)
          return [unboundPrefixExpression, ":number"]
        else
          return unboundPrefixExpression
      else
        for expression, i in unboundPrefixExpression
          unboundPrefixExpression[i] = @bindLabelsToPrefixExpression expression, symbolBindings
        unboundPrefixExpression

    # Recursively checks to see if a certain aliased metric is used in the expression tree
    isAliasInExpression: (alias, expression) ->
      # Expression array contains a single alias
      unless expression instanceof Array
        expressionAlias = expression?.field[0]

        if expressionAlias == alias
          return true
        else
          return false
      if expression.length == 2
        expressionAlias = expression[0]

        if expressionAlias == alias
          return true
        else
          return false
      else
        return (@isAliasInExpression(alias, expression[1]) || @isAliasInExpression(alias, expression[2]))

    # We may either have an expression object or the name of a measure
    _getMeasureReference: (expression, symbolBindings) ->
      if typeof symbolBindings[expression] is 'object'
        return symbolBindings[expression]
      else
        return [symbolBindings[expression], ":value"]


    # Converts a bound metric expression into an unbound infix formula string
    convertPrefixMetricExpressionToInfixFormula: (expression, metrics) ->
      columns = @getColumnAliases(metrics)
      aliases = @genReferenceBindings(columns)
      infixExpression = @_convertPrefixMetricExpressionToInfixFormula(expression, aliases)
      return infixExpression

    # Private method that does the heavy lifting here
    _convertPrefixMetricExpressionToInfixFormula: (item, bindings) ->
      if @_isNested(item)
        formula = @_convertPrefixMetricExpressionToInfixFormula(item[1], bindings) + " " +
                  @_convertPrefixMetricExpressionToInfixFormula(item[0], bindings) + " " +
                  @_convertPrefixMetricExpressionToInfixFormula(item[2], bindings)
        return "(#{formula})"
      else if @_isFormulaToken(item)
        return bindings[item[0]]
      else if @_isFormulaNumber(item)
        return item[0]
      else if @_isFunctionToken(item)
        # These items contain a data perspective
        return bindings[item.field[0]]
      else
        return item

    # Is this array referencing an individual token or does it go deeper?
    _isNested: (item) ->
      return item instanceof Array and item[1] isnt ':value' and item[1] isnt ':number'

    # Is this array referencing an individual token or does it go deeper?
    _isFormulaToken: (item) ->
      return item instanceof Array and item.length is 2 and item[1] is ':value'

    # Is this array referencing an individual token or does it go deeper?
    _isFormulaNumber: (item) ->
      return item instanceof Array and item.length is 2 and item[1] is ':number'

    # Is there a data perspective applied to this?
    _isFunctionToken: (item) ->
      return typeof item is 'object'

    # Converts a the prefix array used in RJQL to an infix string used by restriction sets
    convertPrefixArrayToInfixString: (prefixArray) ->
      unless prefixArray?
        return ""

      formula = @_prefixToInfix(prefixArray)

      # Remove leading and trailing parens, because they have no reason to live
      if formula.match /\(.*\)/
        formula = formula.substr(1)
        formula = formula.substr(0,formula.length-1)

      return formula

    # Recursively convert prefix to infix
    _prefixToInfix: (prefix) ->
      if prefix instanceof Array
        formula = @_prefixToInfix(prefix[1]) + " " +
                  @_prefixToInfix(prefix[0]) + " " +
                  @_prefixToInfix(prefix[2])
        return "(#{formula})"
      else
        return prefix

    # Recursively check that all aliases in expression exist, and that aliases don't reference formulas.
    # An expression typically has three components: an operator and two operands, which
    # themselves can be expressions. If an operand is a string then it is a non-existent alias.
    # If it is an array of length two then it is a metric, with the first element being the unique name.
    _aliasesAreValid: (metrics, expression) ->
      if expression.field? then expr = expression.field # non-standard metrics have operand expression in 'field'
      else expr = expression

      if not (expr instanceof Array)
        return false

      if expr.length < 2 or expr.legnth > 3
        return false

      if expr.length is 2
        for metric in metrics
          if expr[0] is metric.alias and metric.type is 'formula'
            return false
        return true
      else
        return @_aliasesAreValid(metrics, expr[1]) and @_aliasesAreValid(metrics, expr[2])

    # See if this metric has a working expression
    applyFormula: (metrics, metric, version=0.1) ->
      errorString = null

      # Get the column names (or functions if they have a non standard data perspective)
      columnNames = @getColumnNames(metrics, version)
      boundPrefixExpression = @evaluateFormulaIfValid(metric.expressionText, columnNames, 'formula', version)
      if boundPrefixExpression
        if @_aliasesAreValid(metrics, boundPrefixExpression)
          metric.valid = true
          metric.expression = boundPrefixExpression
        else
          errorString = "Formula expression references unavailable metric alias"
          metric.valid = false

      else if metric.expressionText is ''
        metric.valid = 'blank'

      else
        errorString = "Invalid expression"
        metric.valid = false

      return errorString

  ]
